import { Icon, Text } from "@zapier/design-system";
import classNames from "classnames";

import { Placeholder } from "../Placeholder";
import commonStyles from "../AIStreamCreateModal.module.css";

import styles from "./ZapLoader.module.css";

function Steps({ steps }: { steps: string[] }) {
  const stepOne = steps?.[0];
  const stepTwo = steps?.[1];
  const stepThree = steps?.[2];

  return (
    <>
      <div className={styles.box}>
        {!stepOne && <Placeholder width={200} />}
        {stepOne && (
          <Text type="Body1" className={styles.step}>
            {stepOne.replaceAll("_", " ")}
          </Text>
        )}
      </div>
      <div className={styles.line}>
        <Icon name="formAddCircle" size={16} />
      </div>
      <div className={styles.box}>
        {!stepTwo && <Placeholder width={180} />}
        {stepTwo && (
          <div className={styles.step}>
            <Text type="Body1">{stepTwo.replaceAll("_", " ")}</Text>
          </div>
        )}
      </div>
      <div className={styles.line}>
        <Icon name="formAddCircle" size={16} />
      </div>
      <div className={styles.box}>
        {!stepThree && <Placeholder width={240} />}
        {stepThree && (
          <Text type="Body1" className={styles.step}>
            {stepThree.replaceAll("_", " ")}
          </Text>
        )}
      </div>
      <div className={styles.line}>
        <Icon name="formAddCircle" size={16} />
      </div>
    </>
  );
}

export function ZapLoader({
  zsl,
  isLoading,
  isShown,
}: {
  zsl: any;
  isLoading: boolean;
  isShown: boolean;
}) {
  let steps = [];

  // ZapStepDescriptions is going to be deprecated soon, so we need to check for it first
  if (zsl?.zapPrompts?.[0]?.zapStepDescriptions) {
    steps = zsl.zapPrompts[0].zapStepDescriptions;
  } else {
    const trigger = zsl.zaps?.[0]?.[0]?.action_name;
    const action = zsl.zaps?.[0]?.[1]?.action_name;
    const action2 = zsl.zaps?.[0]?.[2]?.action_name;

    steps = [trigger, action, action2];
  }

  return (
    <div
      className={classNames(commonStyles.loadingCard, styles.zapLoadingCard, {
        [commonStyles.loadingCardLoading]: isLoading && !zsl.zapPrompts,
        [commonStyles.shown]: isShown,
      })}
    >
      <div className={commonStyles.cardHeader}>
        <Icon name="miscBoltAltFill" color="BrandOrange" size={16} />
        <p className={commonStyles.title}>Zaps</p>
        {!isLoading && (
          <p className={commonStyles.subtitle}>Do-it-yourself automation</p>
        )}
      </div>
      <div className={styles.pageInner}>
        <Steps steps={steps} />
      </div>
    </div>
  );
}
